import script from "./ImageBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageBox.vue?vue&type=script&setup=true&lang=js"

import "./ImageBox.vue?vue&type=style&index=0&id=722409bc&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722409bc"]])

export default __exports__